<template>
  <div>
    <span class="nsbold"></span>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>